import { useContext } from 'react';
import type { UserContextProps } from '../components/UserProvider/UserContext';
import UserContext from '../components/UserProvider/UserContext';

export default function useUser(): UserContextProps {
  return useContext(UserContext);
}
